import { render, staticRenderFns } from "./NotificationBoxesContainer.vue?vue&type=template&id=71622414&scoped=true"
import script from "./NotificationBoxesContainer.vue?vue&type=script&lang=js"
export * from "./NotificationBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./NotificationBoxesContainer.vue?vue&type=style&index=0&id=71622414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71622414",
  null
  
)

export default component.exports